import { useEffect, useState } from 'react';
import type { AdminUser } from '@/api';

export default function CreditModal({
  user,
  onClose,
  onSave,
}: {
  user: AdminUser | null;
  onClose: () => void;
  onSave: (id: string, credits: number) => void;
}) {
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(user ? String(user.credits) : '');
  }, [user]);

  if (!user) return null;

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const parsed = Number(value);
    if (Number.isNaN(parsed) || parsed < 0) return;
    onSave(user.id, Math.round(parsed));
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="relative w-full max-w-sm bg-surface border border-border rounded-xl p-6">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-textp">Override credits</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-lg text-texts hover:text-textp hover:bg-surface2 transition-colors"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>

        <p className="mt-2 text-sm text-texts">
          Set a new credit balance for <span className="text-textp font-medium">{user.name}</span>.
        </p>

        <form onSubmit={submit} className="mt-4 space-y-4">
          <div>
            <label className="block text-sm font-medium text-textp mb-1.5">Credits</label>
            <input
              value={value}
              onChange={(e) => setValue(e.target.value)}
              autoFocus
              type="number"
              min={0}
              className="w-full bg-bg border border-border rounded-lg px-3 py-2 text-sm font-mono text-textp placeholder:text-texts focus:outline-none focus:border-accent transition-colors"
            />
          </div>

          <div className="flex items-center justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="whitespace-nowrap text-sm text-texts hover:text-textp px-4 py-2 rounded-lg transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="whitespace-nowrap text-sm font-medium text-accent-text bg-accent hover:bg-accent-hover px-4 py-2 rounded-lg transition-colors"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
